export interface WeldSubHeaderProps {
  tag: string;
  pipeMaterial: string;
  pipeDiameter: number;
}
